import React from "react";
import { MarketAgentData } from "../interface";
import { ScoreRadarChart } from "../ScoreRadarChart";

export const MarketAgentComponent = ({
  data,
}: {
  data: MarketAgentData | null;
}) => {
  if (!data) return <div>Loading layout...</div>;

  const chartData = [
    { subject: "Bullish", value: data.scores.bullish_score ?? 0 },
    { subject: "Liquidity", value: data.scores.liquidity_score ?? 0 },
    { subject: "Momentum", value: data.scores.momentum_score ?? 0 },
    { subject: "Holder Health", value: data.scores.holder_health_score ?? 0 },
    { subject: "Confidence", value: data.scores.confidence_score ?? 0 },
  ];

  return (
    <div className="market-report">
      {/* HEADER */}
      <div className="market-report-header">
        <div className="market-report-title">MARKET AGENT REPORT</div>

        <div className="market-report-pills">
          <div className="market-pill market-pill-active">
            {data.market_state.toUpperCase()}
          </div>

          <div className="market-pill market-pill-neutral">
            {data.market_sentiment.toUpperCase()}
          </div>

          <div className="market-pill market-pill-confidence">
            {data.scores.confidence_score} CONFIDENCE
          </div>
        </div>
      </div>

      {/* EXECUTIVE SUMMARY */}
      <div className="market-summary-section">
        <div className="market-section-title">Executive Summary</div>

        <div className="market-summary">{data.market_summary}</div>
      </div>

      {/* SCORE GRID */}
      <div>
        <ScoreRadarChart scores={chartData} type="market" />
      </div>
      <div className="market-score-grid pt-0">
        <div className="market-score-card">
          <div className="market-score-value">{data.scores.bullish_score}</div>
          <div className="market-score-label">Bullish</div>
        </div>

        <div className="market-score-card">
          <div className="market-score-value">
            {data.scores.liquidity_score}
          </div>
          <div className="market-score-label">Liquidity</div>
        </div>

        <div className="market-score-card">
          <div className="market-score-value">{data.scores.momentum_score}</div>
          <div className="market-score-label">Momentum</div>
        </div>

        <div className="market-score-card">
          <div className="market-score-value">
            {data.scores.holder_health_score}
          </div>
          <div className="market-score-label">Holder Health</div>
        </div>

        <div className="market-score-card">
          <div className="market-score-value">
            {data.scores.confidence_score}
          </div>
          <div className="market-score-label">Confidence</div>
        </div>
      </div>

      {/* ANALYSIS */}

      <div className="market-analysis-section">
        <div className="market-analysis-title">Activity Analysis</div>

        <div className="market-analysis-text">{data.activity_analysis}</div>
      </div>

      <div className="market-analysis-section">
        <div className="market-analysis-title">Liquidity Analysis</div>

        <div className="market-analysis-text">{data.liquidity_analysis}</div>
      </div>

      <div className="market-analysis-section">
        <div className="market-analysis-title">Holder Analysis</div>

        <div className="market-analysis-text">{data.holder_analysis}</div>
      </div>

      <div className="market-analysis-section">
        <div className="market-analysis-title">Price Analysis</div>

        <div className="market-analysis-text">{data.price_analysis}</div>
      </div>

      {/* SIGNALS */}

      <div className="market-block-section">
        <div className="market-section-title">Signals</div>

        <div className="market-signals-list">
          {data.signals.map((signal, index) => (
            <div key={index} className="market-signal">
              {signal}
            </div>
          ))}
        </div>
      </div>

      {/* RISK FLAGS */}

      <div className="market-block-section">
        <div className="market-section-title">Risk Flags</div>

        <div className="market-risk-list">
          {data.risk_flags.map((risik, index) => (
            <div key={index} className="market-risk-flag">
              {risik}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
